var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('team-card',{attrs:{"show-actions-buttons":false,"team":_vm.team,"max-title-length":20,"loading":_vm.cardLoader},on:{"on-team-selected":function($event){return _vm.onTeamSelected($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }